<template>
  <v-container>
    <v-row justify="center">
      <v-col :lg="4">
        <v-card>
          <v-card-title>
            <h3 class="headline">{{ $t('Send Password Reset Link') }}</h3>
          </v-card-title>
          <form @submit.prevent="submit">
            <v-card-text>
              <validation-observer ref="form">
                <validation-provider v-slot="{errors}" name="email" rules="required|email|max:255">
                  <v-text-field
                    name="email"
                    :label="$t('E-mail')"
                    id="email"
                    type="email"
                    v-model="email"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
              </validation-observer>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :to="{name: 'Welcome'}">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" :loading="loading" color="success">{{ $t('Send') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auth from "@/api/auth";
import snackbar from "@/mixins/snackbar";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "PasswordResetForm",
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      email: "",
      loading: false,
      error: false,
      success: false
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.loading = true;

        const data = {
          email: this.email
        };

        auth
          .sendResetLink(data)
          .then(() => {
            this.loading = false;
            this.snackbar(
              "success",
              this.$t("We have emailed your password reset link!")
            );
          })
          .catch(() => {
            this.loading = false;
            this.snackbar(
              "error",
              this.$t("An error occured during sending e-mail, please try again")
            );
          });
      });
    }
  }
};
</script>